import React, { useContext, useEffect, useState } from "react";

import { IconButton, Tooltip, Typography } from "@mui/material";
import { Collapse, Modal } from "react-bootstrap";

import moment from "moment";
import ButtonComponent from "../../Components/ButtonForm/Button";
import DynamicGrid from "../../Components/DynamicGrid/DynamicGrid";
import OverflowTip from "../../Components/OverflowToolTip/OverflowToolTip";
import {
  GetsubscriptionDashboardDetails,
  GetYearDropDown,
  GetSubMemberDetails,
  getConfigValues,
  CheckLoanIsOnMember,
  UpdateInitialAmount,
  insertIntoMemberEnrollmentHistory,
  GetsubscriptionExportToExcel,
} from "../../Helpers/APIEndPoints/EndPoints";
import { DATE_DISPLAY_FORMAT } from "../../Helpers/Constants/Constants";
import { getContext, LoaderContext } from "../../Helpers/Context/Context";
import { ApiStatus } from "../../Helpers/Enums/ApiStatus";
import { APICall } from "../../Helpers/Network/APICalls";
import notify, { ToastType } from "../../Helpers/ToastNotification";
import SelectForm from "../../Components/SelectForm/SelectForm";
import InputForm from "../../Components/InputForm/InputForm";
import TrackFalseSlider from "../../Components/Slider/Slider";
import DateForm from "../../Components/DateForm/DateForm";
import { SanjeevaniEnum } from "../SanjeevaniYojna/SanjeevaniEnum/SanjeevaniEnum";
import axios from "axios";
import fileDownload from "js-file-download";
import { fetchAuthToken } from "../../Helpers/Network/OAuthHandler";
import CustomModal from "../../Components/Modal/CustomModal";

const SubscriptionPlanView = () => {
  const context = getContext();

  const { showLoader, hideLoader } = useContext(LoaderContext);
  const [yearOptions, setYearOptions] = useState<any>([]);
  const currentYear = moment().year();
  const yearOptionsWithCurrent = [
    ...yearOptions,
    { value: currentYear.toString(), label: currentYear.toString() },
  ];
  const [selectedYear, setSelectedYear] = useState({
    value: currentYear.toString(),
    label: currentYear.toString(),
  });
  const [sortDirection, setSortDirection] = useState("");
  const [pageSize] = useState(10);
  const [dataCount, setDataCount] = useState(0);
  const [start, setStart] = useState(0);
  const [sortColumn, setSortColumn] = useState("");
  const [searchText, setSearchText] = useState("");
  const [dashboardData, setDashboardData] = useState([]);
  const [empName, setEmpName] = useState(null);
  const [initialAmount, setInitialAmount] = useState(0);
  const [MonthlyDeductions, setMonthlyDeductions] = useState(0);
  const [checkInitialAmount, setCheckInitialAmount] = useState(0);
  const [dojSer, setDojSer] = useState(null);
  const [dojCs, setDojCs] = useState(null);
  const [unit, setUnit] = useState(null);
  const [selectedValue, setSelectedValue] = useState(0);
  const [initialDeposit, setInitialDeposit] = useState(301);
  const [payable, setPayable] = useState(601);
  const [initialdisabled, setInitialDisabled] = React.useState(false);
  const [modalShow, setModalShow] = React.useState(false);
  const [monthlyDeclaration, setMonthlyDeclarations] = useState(300);
  const [sliderMin, setSliderMin] = useState(0);
  const [sliderMax, setSliderMax] = useState(0);
  const [customSliderMarks, setCustomSliderMarks] = useState([]);
  const [checkLoanId, setCheckLoanId] = useState(0);
  const [errorMessage, setErrorMessage] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [data, setData] = useState({
    accholdername: "",
    bankName: "",
    ifsc: "",
    transactionRef: 0,
    amount: 0,
    transactionDate: null,
    typeoftransaction: null,
    statusId: 0,
    statusName: "",
    rejectedRemarks: [],
  });
  const [dashboardFilterOn, setDashboardFilterOn] = useState<boolean>(false);

  const onChange = (key, value) => {
    setData({ ...data, [key]: value });
  };

  const getConfigData = async () => {
    let temp = [];
    let minLimitKey = "";
    let maxLimitKey = "";
    let customSliderMarks = [];

    temp = ["MemberSubMinAmount", "MemberSubMaxAmount", "SNJYSubmit"];
    minLimitKey = "MemberSubMinAmount";
    maxLimitKey = "MemberSubMaxAmount";
    let param = `${getConfigValues}`;
    const getdata = await APICall(param, { Keys: temp });
    if (getdata.Status === ApiStatus.OK && getdata?.Data?.length > 0) {
      const confData = getdata?.Data;
      const minLimit =
        confData.find((config) => config.Key === minLimitKey)?.Value || 0;
      const numMin = Number(minLimit);
      const maxLimit =
        confData.find((config) => config.Key === maxLimitKey)?.Value || 0;
      const numMax = Number(maxLimit);

      setSliderMin(numMin);
      setSliderMax(numMax);
      customSliderMarks = [
        { value: numMin, label: `Min ${numMin}` },
        // { value: 100, label: `` },
        // { value: 500, label: `` },
        // { value: 1000, label: `` },
        // { value: 1500, label: `` },
        // { value: 2000, label: `` },
        // { value: 2500, label: `` },
        // { value: 3000, label: `` },
        // { value: 3500, label: `` },
        // { value: 4000, label: `` },
        // { value: 4500, label: `` },
        { value: numMax, label: `Max ${numMax}` },
      ];
      setCustomSliderMarks(customSliderMarks);

      // additional code to display label dynamically
      // const marks = [];
      // for (let i = numMin; i <= numMax; i += 600) {
      //   marks.push({ value: i, label: `${i}` });
      // }
      // marks.push({ value: numMax, label: `${numMax}` });
      // setCustomSliderMarks(marks);
    }
  };

  const handleSliderChange = (e) => {
    const newTotalAmount = parseInt(e.target.value);
    // if (checkLoanId > 0) {
    //   if (initialAmount <= newTotalAmount) {
    //     // setInitialAmount(newTotalAmount);
    //     setCheckInitialAmount(newTotalAmount);
    //     setSelectedValue(newTotalAmount);
    //   } else if (checkInitialAmount > newTotalAmount) {
    //     return;
    //   }
    // } else if (checkLoanId === 0) {
    // setInitialAmount(newTotalAmount);
    setCheckInitialAmount(newTotalAmount);
    setSelectedValue(newTotalAmount);
    // }
  };

  const payAble = (key: any, value: any) => {
    if (key === "initaldeposit") {
      setInitialDeposit(value.target.value + 1);
      setPayable(monthlyDeclaration + value.target.value + 1);
      onChange("amount", monthlyDeclaration + value.target.value + 1);
    }
    if (key === "monthlydeductions") {
      setMonthlyDeclarations(value.target.value);
      setPayable(initialDeposit + value.target.value);
      onChange("amount", monthlyDeclaration + value.target.value + 1);
    }
    //setPayable(initialDeposit + monthlyDeclaration)
  };

  const GetMemberSubScription = async () => {
    showLoader();
    try {
      const param = {
        MemberId: context?.MemberId,
      };

      const resp = await APICall(GetSubMemberDetails, param);
      if (resp.Status === ApiStatus.OK) {
        const {
          EmpName,
          InitialDeposit,
          MonthlyDeductions,
          DateOfJoiningS,
          DateOfJOiningCS,
          UnitName,
        } = resp.Data;
        setEmpName(EmpName);
        setInitialAmount(InitialDeposit);
        setMonthlyDeductions(MonthlyDeductions);
        setCheckInitialAmount(MonthlyDeductions);
        setDojSer(DateOfJoiningS);
        setDojCs(DateOfJOiningCS);
        setUnit(UnitName);
      }
    } finally {
      hideLoader();
    }
  };

  const CheckLoan = async () => {
    try {
      const param = {
        MemberId: context?.MemberId,
      };

      const resp = await APICall(CheckLoanIsOnMember, param);
      if (resp.Status === ApiStatus.OK) {
        const isLoan = resp.Data.Id;
        setCheckLoanId(isLoan);
      }
    } catch (error) {
      console.error("Error:", error);
      hideLoader();
    } finally {
      hideLoader();
    }
  };

  const getSubscriptionDetails = async () => {
    showLoader();
    try {
      const data = {
        MemberId: context?.MemberId,
        Year: selectedYear.value,
        MemberNumber: 0,
        resultsPerPage: 10,
        searchText: searchText,
        sortColumn: sortColumn,
        sortDirection: sortDirection,
        start: start,
      };

      const resp = await APICall(GetsubscriptionDashboardDetails, data);

      if (resp.Status === ApiStatus.OK) {
        const dataArr = resp?.Data || [];
        setDashboardData(dataArr);
        setDataCount(dataArr.length);
      }
    } finally {
      hideLoader();
    }
  };

  const GetYearDropDowndetails = async () => {
    showLoader();
    try {
      const resp = await APICall(GetYearDropDown, null);

      if (resp.Status === ApiStatus.OK && resp?.Data?.length > 0) {
        let checkYear = resp.Data.map((item) => item.Name);
        if (!checkYear.includes(currentYear.toString())) {
          checkYear.push(currentYear.toString());
        }
        let yearOptions = checkYear.map((year) => ({
          value: year,
          label: year,
        }));

        setYearOptions(yearOptions);
      } else if (resp?.Data === null) {
        notify(1, resp.Message);
      }
    } finally {
      hideLoader();
    }
  };

  const CustomCellComponent = (
    value: any,
    tableMeta: any,
    isDate: boolean = false
  ) => {
    return (
      <>
        <OverflowTip>
          <Typography
            fontFamily={"Georama-Regular"}
            fontSize={"14px"}
            component={"span"}
            noWrap={true}
          >
            {!isDate
              ? value
              : value
              ? moment(value).format(DATE_DISPLAY_FORMAT)
              : ""}
          </Typography>
        </OverflowTip>
      </>
    );
  };

  const CommonCellOptions = (isDate: boolean = false) => {
    return {
      filter: true,
      sort: true,
      sortDescFirst: true,
      customBodyRender: (value, tableMeta) =>
        CustomCellComponent(value, tableMeta, isDate),
    };
  };

  const Options = {
    showEmptyDataSourceMessage: true,
    selectableRows: "none",
    count: dataCount,
    rowsPerPage: pageSize,
    serverSide: true,
    rowsPerPageOptions: [],
    download: false,
    print: false,
    viewColumns: false,
    filter: false,
    search: false,
    responsive: "standard",
    onChangeRowsPerPage: () => {},
    onSearchChange: (searchText) => {
      if (searchText !== null) {
        setSearchText(searchText);
      } else {
        setSearchText("");
      }
      setStart(0);
    },
    onColumnSortChange: async (sortColumn, sortDirection) => {
      if (sortDirection === "asc") {
        setSortColumn(sortColumn);
        setSortDirection(sortDirection);
      }
      if (sortDirection === "desc") {
        setSortColumn(sortColumn);
        setSortDirection(sortDirection);
      }
      setStart(0);
    },
    onChangePage: async (page) => {
      setStart(page * pageSize);
    },
  };

  const GridColumns = [
    {
      name: "Months",
      label: "MONTH",
      options: CommonCellOptions(),
    },
    {
      name: "Share",
      label: "SHARE",
      options: CommonCellOptions(),
    },
    // {
    //   name: "Share1",
    //   label: "SHARE 1",
    //   options: CommonCellOptions(),
    // },
    // {
    //   name: "Share2",
    //   label: "SHARE 2",
    //   options: CommonCellOptions(),
    // },
    {
      name: "CD",
      label: "CD",
      options: CommonCellOptions(),
    },
    {
      name: "FD",
      label: "FD",
      options: CommonCellOptions(),
    },
    {
      name: "AdditionalFD",
      label: "AFD",
      options: CommonCellOptions(),
    },
     {
      name: "MBF",
      label: "MBF",
      options: CommonCellOptions(),
    },
    {
      name: "Total",
      label: "TOTAL",
      options: CommonCellOptions(),
    },
    {
      name: "MonthlyDeductions",
      label: "SUBSCRIPTION",
      options: CommonCellOptions(),
    },
  ];

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  const handleYesFunctionality = () => {
    
    setModalShow(false);
    handleRoleSubmit();
  };

  const handleRoleSubmit = async () => {
    
    showLoader();
    let isValid = true;
    if (checkInitialAmount >= sliderMax) {
      isValid = true;
    }
    if (checkInitialAmount < MonthlyDeductions) {
      isValid = true;
    }
    if (MonthlyDeductions === sliderMax && checkInitialAmount >= MonthlyDeductions) {
      setErrorMessage(
        `Your total Initial Amount exceeds ${sliderMax} and your actual Initial Amount is ${MonthlyDeductions}.`
      );
      isValid = false;
    }
    if (isValid) {
      try {
        const param = {
          MemberId: context?.MemberId,
          InitialDeposit: checkInitialAmount,
        };
        const resp = await APICall(UpdateInitialAmount, param);
        if (resp.Status === ApiStatus.OK) {
          notify(0, "successfully submited");
          setModalShow(false);
          setModalOpen(false);
          GetMemberSubScription();
          GetYearDropDowndetails();
          getSubscriptionDetails();
          getConfigData();
          CheckLoan();
        }
      } catch (error) {
        console.error("Error:", error);
        hideLoader();
      } finally {
        hideLoader();
      }
    }
    hideLoader();
  };

  const handleExportToExcel = () => {
    
    if (dataCount === 0) {
      notify(ToastType.Error, "No data available");
    } else {
      ExportToExcel();
    }
  };

  const ExportToExcel = async () => {
    let obj = {
      start: start,
      resultsPerPage: pageSize,
      searchText: searchText,
      sortColumn: sortColumn,
      sortDirection: sortDirection,
      MemberId: context?.MemberId,
      Year: selectedYear.value,
      // FromDate: currentFilters?.fromDate || "",
      // ToDate: currentFilters?.toDate || "",
    };
    let token = await fetchAuthToken();
    axios
      .request({
        responseType: "blob",
        method: "POST",
        url: GetsubscriptionExportToExcel,
        data: obj,
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          "Access-Control-Allow-Headers": "*",
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
     
        fileDownload(
          response.data,
          `Subscription Plan Statment_` +
            `${moment(new Date()).format(moment.HTML5_FMT.DATE)}` +
            `.xlsx`
        );
      })
      .catch((error) => {
       
        notify(ToastType.Error, "Failed to export data.");
      });
  };

  useEffect(() => {
    GetMemberSubScription();
    GetYearDropDowndetails();
    getConfigData();
    CheckLoan();
  }, []);

  useEffect(() => {
    getSubscriptionDetails();
  }, [selectedYear, searchText]);

  useEffect(() => {
    // Update marks whenever selectedValue changes
    const customSliderMarks = [
      { value: sliderMin, label: `Min ${sliderMin}` },
      { value: selectedValue, label: `${selectedValue}` },
      { value: sliderMax, label: `Max ${sliderMax}` },
    ];
    setCustomSliderMarks(customSliderMarks);
  }, [selectedValue]);
  return (
    <>
      <CustomModal
        show2={modalOpen}
        handleClose2={handleCloseModal}
        onHide2={() => setModalOpen(false)}
        title="Confirmation Message"
        body={"Are you sure you want to update monthly deduction amount ?"}
        hideButton1={false}
        buttonLabel1="Yes"
        handleYesFunctionality={handleYesFunctionality}
        buttonLabel2="No"
        hideButton2={false}
      />
      <Modal
        show={modalShow}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        backdrop="static"
        keyboard={false}
      >
        <Modal.Body>
          <div className="row d-flex justify-content-center">
            <div
              className="col-lg-2 col-sm-2 col-xs-2 "
              style={{ marginTop: "20px" }}
            >
              <div className="form-group">
                <h4>Amount</h4>
              </div>
            </div>
            {/* Main slider */}
            <div
              className="col-lg-8 col-sm-6 col-xs-6 "
              style={{ marginTop: "20px", padding: "0px 60px" }}
            >
              <TrackFalseSlider
                valuetext={(e) => {
                  payAble("monthlydeductions", e);
                  handleSliderChange(e);
                }}
                value={checkInitialAmount}
                disabled={initialdisabled}
                min={sliderMin}
                max={sliderMax}
                step={100}
                marks={customSliderMarks}
              />
            </div>
            {/* Display slider selected amount */}
            <div
              className="col-lg-2 col-sm-2 col-xs-2 "
              style={{ marginTop: "20px" }}
            >
              <div className="form-group">
                <InputForm
                  placeholder={""}
                  value={checkInitialAmount}
                  disabled={MonthlyDeductions}
                />
                {errorMessage && <p className="text-danger">{errorMessage}</p>}
              </div>
            </div>
            {/* Display slider Message */}
            <div className="form-group">
              <label style={{ fontSize: "smaller" }}>
                (This amount will ne deducted monthly from your salary)
              </label>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="text-center btn-submit"
            onClick={
              () => {
                setModalOpen(true);
                setModalShow(false);
              }
              // handleRoleSubmit
            }
            // disabled={
            //   (checkInitialAmount > sliderMax || initialAmount === sliderMax) &&
            //   checkLoanId === 0
            // }
            disabled={
              initialAmount === sliderMax && checkInitialAmount >= initialAmount
            }
          >
            {" "}
            Submit
          </button>
          <button
            className="text-center btn-submit"
            onClick={() => {
              setModalShow(false);
              setErrorMessage("");
            }}
          >
            Close
          </button>
        </Modal.Footer>
      </Modal>
      {/* Change In Upper Details */}


      <div>
  <div className="row">
    {/* Employee Details */}
    <div className="col-12">
      <div className="form-group d-flex justify-content-between align-items-center flex-wrap">
        {/* Employee Name */}
        <p className="m-2">
          <span className="font-weight-bold">Employee Name:</span> {empName}
        </p>
        {/* Unit Code */}
        <p className="m-2">
          <span className="font-weight-bold">Unit:</span> {unit}
        </p>
        {/* Monthly Deduction */}
        <p className="m-2">
          <span className="font-weight-bold">Monthly Deduction:</span> {MonthlyDeductions}
          <i className="fas fa-edit ml-2" onClick={() => setModalShow(true)}></i>
        </p>
        {/* Date of Joining M&M */}
        <p className="m-2">
          <span className="font-weight-bold">Date of Joining M&M:</span> {moment(dojSer).format(DATE_DISPLAY_FORMAT)}
        </p>
        {/* Date of Joining CS */}
        <p className="m-2">
          <span className="font-weight-bold">Date of Joining CS:</span> {moment(dojCs).format(DATE_DISPLAY_FORMAT)}
        </p>
      </div>
    </div>
  </div>

  {/* Filter Section */}
  <div className="row">
    <div className="col-lg-12 d-flex justify-content-end align-items-center mb-2">
      <div className="col-lg-3">
        <div className="input-group">
          <input
            className="form-control py-2 border-right-0 border"
            type="search"
            value={searchText}
            placeholder="Search"
            onChange={(e) => setSearchText(e.target.value)}
          />
          <span className="input-group-append">
            <div className="input-group-text bg-transparent">
              <i className="fa fa-search"></i>
            </div>
          </span>
        </div>
      </div>
      <Tooltip title="Export to excel" style={{ cursor: "pointer" }}>
        <button className="btn btn-submit" onClick={handleExportToExcel}>
          <i className="fa fa-download"></i>
        </button>
      </Tooltip>
      <Tooltip title="Filters" style={{ marginLeft: "5px", cursor: "pointer" }}>
        <ButtonComponent
          onClick={() => setDashboardFilterOn(!dashboardFilterOn)}
          className="btn btn-submit"
          icon={"fa fa-filter"}
          value=""
        />
      </Tooltip>
    </div>
  </div>
  
  <Collapse in={dashboardFilterOn}>
    <div className="filter-content pt-2 mb-2">
      <div className="row">
        <div className="col-lg-3 col-sm-3 col-xs-12 mb-2">
          <div className="form-group">
            <label>Year</label>
            <SelectForm
              options={yearOptionsWithCurrent}
              placeholder="Year"
              isDisabled={false}
              value={selectedYear}
              onChange={(selectedOption) => setSelectedYear(selectedOption)}
              isMulti={false}
              noIndicator={false}
              noSeparator={false}
            />
          </div>
        </div>
      </div>
    </div>
  </Collapse>

  {/* Dynamic Grid */}
  <div>
    <DynamicGrid options={Options} data={dashboardData} columns={GridColumns} />
  </div>
</div>

    </>
  );
};

export default SubscriptionPlanView;
